<template>
  <div id="outer">
    <input 
    type="button" 
    v-for="(val,index) in buttonsval" 
    :value="val" 
    :key="val"
    @click="handleChange(index)"
    />
    <div class="div1" :style="styleObject" v-show="show"></div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      show:true,
      styleObject:{
        width:'',
        height:'',
        background:''
      },
      buttonsval:[
        '变宽',
        '变高',
        '变色',
        '隐藏',
        '重置'
      ],
      
    }
  },
  methods:{
    handleChange(index){
      switch(index){
        case 0:
          this.styleObject.width='200px';
          break;
        case 1:
          this.styleObject.height='200px';
          break;
        case 2:
          this.styleObject.background='red';
          break;
        case 3:
          this.show=false;
          break;
        case 4:
          this.styleObject.width='100px';
          this.styleObject.height='100px';
          this.styleObject.background='black';
          this.show=true;
      }
    }
  }
}
</script>
<style>
#outer{
  width: 500px;
  margin: 0 auto;
  padding: 0;
  text-align: center;
}
.div1{
  width: 100px;
  height: 100px;
  background: black;
  margin: 10px auto;
  display: block;
}
</style>
